(function () {
  if (window.customElements.get("cart-drawer-collections-slider")) return;

  class CartDrawerCollectionsSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this._waitInterval = null;
    }

    connectedCallback() {
      if (typeof Swiper === "undefined") {
        this._waitInterval = window.setInterval(() => {
          if (typeof Swiper !== "undefined") {
            window.clearInterval(this._waitInterval);
            this._waitInterval = null;
            this.initSwiper();
          }
        }, 50);
      } else {
        requestAnimationFrame(() => this.initSwiper());
      }
    }

    disconnectedCallback() {
      if (this._waitInterval) {
        window.clearInterval(this._waitInterval);
        this._waitInterval = null;
      }
      this.destroySwiper();
    }

    initSwiper() {
      if (!this.isConnected) return;
      this.destroySwiper();

      const root = this.querySelector("[data-slider-root]");
      const prev = this.querySelector("[data-slider-prev]");
      const next = this.querySelector("[data-slider-next]");
      const paginationEl = this.querySelector("[data-slider-pagination]");

      if (!root || typeof Swiper === "undefined") return;

      const columns = parseFloat(this.dataset.columns) || 3;
      const showNav = this.dataset.navigation === "true";
      const showPag = this.dataset.pagination === "true";

      this.swiper = new Swiper(root, {
        slidesPerView: columns,
        spaceBetween: 10,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true,
        navigation: showNav
          ? {
              prevEl: prev,
              nextEl: next,
              disabledClass: "is-disabled",
              lockClass: "swiper-button-lock",
            }
          : false,
        pagination: showPag
          ? {
              el: paginationEl,
              clickable: true,
            }
          : false,
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 2,
        },
      });
    }

    destroySwiper() {
      if (this.swiper && typeof this.swiper.destroy === "function") {
        try {
          this.swiper.destroy(true, true);
        } catch (e) {}
      }
      this.swiper = null;
    }
  }

  window.customElements.define(
    "cart-drawer-collections-slider",
    CartDrawerCollectionsSlider
  );
})();
